<template>
  <div class="baseContent-warp">
    <Card>
      <span slot="title">患者随访列表</span>
      <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getFollowUpList)">刷新</el-button>
      <div slot="content" class="wrap">
        <!-- 条件查询 -->
        <div class="search" v-if="$session.get('user').type != '0'">
          <el-form :inline="true" :model="searchForm">
            <el-form-item label="医生">
              <el-select allow-create clearable v-model="searchForm.doctorName" placeholder="请选择医生" filterable
                default-first-option>
                <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.label">
                  <span class="fl">{{ item.label }}</span>
                  <span class="select-flex">{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="$refresh(getFollowUpList)">查询</el-button>
              <el-button icon="el-icon-refresh" @click="$reset(getFollowUpList)">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 操作按钮 -->
        <div class="btn" v-if="$session.get('user').type == 1 || $session.get('user').type == 0">
          <el-button icon="el-icon-plus" type="primary" v-show="activeIndex == '-1'"
            @click="followUpModify(multipleSelection, 0)">批量添加计划</el-button>
          <el-button icon="el-icon-plus" type="primary" v-show="activeIndex == '0'"
            @click="addFollowUpList(multipleSelection)">批量自动随访</el-button>
          <el-button icon="el-icon-plus" type="primary" v-show="activeIndex == '-2'"
            @click="followUpAgain(multipleSelection)">批量再次推送</el-button>
          <el-button icon="el-icon-delete" type="danger" @click="followUpModify(multipleSelection, -1)"
            v-show="activeIndex == '0' || activeIndex == '-2' || activeIndex == '1'">批量取消计划</el-button>
        </div>
        <!-- 状态菜单 -->
        <el-tabs v-model="activeIndex" mode="horizontal" @tab-click="handleSelect">
          <el-tab-pane :label="`待随访(${beforeFollowUpNumber})`" name="0" />
          <el-tab-pane :label="`待推送(${waitPushNumber})`" name="1" />
          <el-tab-pane :label="`推送成功(${followUpNumber})`" name="2" />
          <el-tab-pane :label="`推送失败(${erroPushNumber})`" name="-2" />
          <el-tab-pane :label="`随访完成(${afterFollowUpNumber})`" name="3" />
          <el-tab-pane :label="`不随访(${noFollowUpNumber})`" name="-1" />
        </el-tabs>
        <div>
          <!-- 随访列表 -->
          <el-table v-loading="loading" :data="followUpList" ref="multipleTable" :max-height="tableHeight"
            @selection-change="val => $handleSelectionChange(val, true)" border>
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column prop="patientName" label="患者姓名" />
            <el-table-column prop="doctorName" label="看诊医生" />
            <el-table-column prop="remark" label="推送失败原因" v-if="activeIndex == '-2'" min-width="150" />
            <el-table-column prop="createTime" label="创建时间" min-width="140" />
            <el-table-column prop="examTime" v-if="activeIndex != '-1' && activeIndex != '0'" label="推送时间"
              min-width="130" />
            <el-table-column prop="completeTime" v-if="activeIndex == '3'" label="完成时间" min-width="130" />
            <el-table-column label="操作" width="460"
              v-if="$session.get('user').type == 1 || $session.get('user').type == 0">
              <template slot-scope="scope">
                <div class="button">
                  <el-button icon="el-icon-plus" type="primary" v-show="scope.row.status == '-1'"
                    @click="followUpModify([scope.row], 0)">添加计划</el-button>
                  <el-button icon="el-icon-plus" type="primary" v-show="scope.row.status == '0'"
                    @click="addFollowUp(scope.row, '1')">自动随访</el-button>
                  <el-button icon="el-icon-plus" type="primary" v-show="scope.row.status == '0'"
                    @click="addFollowUp(scope.row, '0')">人工随访</el-button>
                  <el-button icon="el-icon-plus" type="primary" v-show="scope.row.status == '-2'"
                    @click="followUpAgain([scope.row])">再次推送</el-button>
                  <el-button icon="el-icon-delete" type="danger" @click="followUpModify([scope.row], -1)"
                    v-show="scope.row.status == '0' || scope.row.status == '-2' || scope.row.status == '1'">取消计划</el-button>
                  <el-button icon="el-icon-view"
                    @click="$router.push(`./followupdetails?examRecordId=${scope.row.examRecordId}`)">随访详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination class="mt20" @current-change="page => $handleCurrentChange(page, getFollowUpList)" :total="total"
            :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
        </div>
        <!-- 新建随访 -->
        <el-dialog class="followUpEdit" title="新建随访" :visible.sync="dialogVisible" width="720px"
          :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
          <el-form :model="editForm" :rules="editFormRules" ref="editForm" inline label-width="80px"
            :style="{ maxHeight: formHeight + 'px' }">
            <el-form-item label="随访人员" prop="examRealityName">
              <el-input v-model="editForm.examRealityName" disabled />
            </el-form-item>
            <el-form-item label="随访分类" prop="targer">
              <el-radio-group v-model="editForm.targer" @change="targerChange">
                <el-radio label="0">复诊随访</el-radio>
                <el-radio label="1">日常随访</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否挂号" prop="isRegister">
              <el-radio-group v-model="editForm.isRegister">
                <el-radio label="0">否</el-radio>
                <el-radio label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="问卷模板" v-if="editForm.targer == '0'" prop="examTemplateId">
              <el-select v-model="editForm.examTemplateId" placeholder="请选择随访模板" @change="setQuestion">
                <el-option v-for="item in templateOptions" :key="item.examTemplateId" :label="item.examTemplateName"
                  :value="item.examTemplateId" />
              </el-select>
            </el-form-item>
            <el-form-item label="回访内容" v-if="editForm.targer == '1'" prop="hintMessage">
              <el-select allow-create clearable filterable default-first-option v-model="editForm.hintMessage"
                placeholder="请选择或输入日常随访回访内容">
                <el-option v-for="item in hintList" :key="item.examHintMessageTemplate" :value="item.content"
                  :label="item.content" />
              </el-select>
            </el-form-item>
            <el-form-item label="随访问卷" class="questionList" prop="questionsList"
              v-if="(editForm.questionsList != undefined && JSON.stringify(editForm.questionsList).length != 2) && editForm.targer == '0' && type == '0'">
              <div v-for="(item, i) in editForm.questionsList" :key="item.examRecordQuestionsId">
                <el-form-item v-if="item.questionsType == 2" :label="'题' + (i + 1) + '：' + item.questionsTitle"
                  :prop="'questionsList.' + i + '.testAnswer'"
                  :rules="[{ required: true, message: '简答答案不能为空！', trigger: 'blur' }]">
                  <el-input v-model="item.testAnswer" placeholder="请输入简答题答案" />
                </el-form-item>
                <el-form-item v-else-if="item.questionsType == 0" :label="'题' + (i + 1) + '：' + item.questionsTitle"
                  :prop="'questionsList.' + i + '.selectAnswerId'"
                  :rules="[{ required: true, message: '选项答案不能为空！', trigger: 'blur' }]">
                  <el-radio-group v-model="item.selectAnswerId" @change="val => setRadioAnswer(val, item)">
                    <el-radio v-for="answer in item.templateAnswers" :key="answer.examRecordAnswerId"
                      :label="answer.examRecordAnswerId">
                      <div>{{ answer.answerContent }}</div>
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item v-else :label="'题' + (i + 1) + '：' + item.questionsTitle"
                  :prop="'questionsList.' + i + '.selectAnswerIds'"
                  :rules="[{ required: true, message: '选项答案不能为空！', trigger: 'blur' }]">
                  <el-checkbox-group v-model="item.selectAnswerIds" @change="val => setCheckboxAnswer(val, item)">
                    <el-checkbox v-for="answer in item.templateAnswers" :key="answer.examRecordAnswerId"
                      :label="answer.examRecordAnswerId">
                      <div>{{ answer.answerContent }}</div>
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
            </el-form-item>
            <div v-if="type == '0'">
              <el-form-item label="随访途径" prop="channel">
                <el-radio-group v-model="editForm.channel">
                  <el-radio label="电话" />
                  <el-radio label="微信" />
                  <el-radio label="当面" />
                </el-radio-group>
              </el-form-item>
              <el-form-item label="随访凭证" prop="imgAddr">
                <div v-if="editForm.imgAddr" class="img">
                  <img :src="editForm.imgAddr" />
                  <div @click="editImg" class="del">x</div>
                </div>
                <el-upload v-else :action="uploadUrl" list-type="picture-card" :on-success="handleImgSuccess"
                  name="uploadFile" :data="{ storagePath: 'picture' }"><i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </div>
            <el-form-item label="其他信息" prop="describe">
              <el-input v-model="editForm.describe" placeholder="请输入其他用户反馈信息" />
            </el-form-item>
            <el-form-item label="随访时间" prop="examTime">
              <el-date-picker v-model="editForm.examTime" value-format="yyyy-MM-dd HH:mm" type="datetime"
                placeholder="请选择随访时间" />
            </el-form-item>
            <el-form-item label="复诊时间" prop="visitTime">
              <el-date-picker v-model="editForm.visitTime" value-format="yyyy-MM-dd HH:mm" type="datetime"
                placeholder="请选择复诊时间" />
            </el-form-item>
          </el-form>
          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button type="success" @click="saveFollowUp(editForm)">保存修改</el-button>
            <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
          </span>
        </el-dialog>
        <!-- 再次推送时间设置 -->
        <el-dialog title="再次推送" :visible.sync="againVisible" width="400px"
          :before-close="done => $handleClose(done, 'examTimeObj')">
          <el-form :model="examTimeObj" :rules="editFormRules" ref="examTimeObj" inline label-width="80px">
            <el-form-item label="随访时间" prop="examTime">
              <el-date-picker class="w240" v-model="examTimeObj.examTime" value-format="yyyy-MM-dd HH:mm" type="datetime"
                placeholder="请选择随访时间" />
            </el-form-item>
          </el-form>
          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button type="success" @click="followUpAgainSave(editForm)">确认推送</el-button>
            <el-button @click="$cancel('againVisible', 'editForm')">取 消</el-button>
          </span>
        </el-dialog>

      </div>
    </Card>
  </div>
</template>

<script lang="js">
import { templateList, questionList, hintBankList } from "@/api/followup-questionnaire"; // 获取问卷请求
import { followUpAuto, followUpArtificial, followUpList, followUpModified, statusNum, followUpAgain } from "@/api/followup"; // 获取随访请求
export default {
  name: "FollowUp",
  data() {
    return {
      loading: true, // 加载中
      searchForm: { doctorName: null }, // 查询表单
      followUpList: [], // 随访列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      multipleSelection: [], // 被选中行
      noFollowUpNumber: 0, // 不回访数量
      waitPushNumber: 0, // 待推送数量
      followUpNumber: 0, // 已推送数量
      beforeFollowUpNumber: 0, // 待回访数量
      afterFollowUpNumber: 0, // 随访完成数量
      erroPushNumber: 0, // 推送失败数量
      activeIndex: this.$route.query.status || '0', // 激活面板名称
      doctorOptions: [{ label: '-', value: '-', phone: '-' }], // 馆内医生列表
      dialogVisible: false, // 随访模态框状态
      uploadUrl: this.$baseUrl + '/file/upload', // 图片上传接口地址
      editFormRules: {
        examTime: [{ required: true, message: "随访时间不能为空！", trigger: "blur" }],
        targer: [{ required: true, message: "随访分类不能为空！", trigger: "blur" }],
        examRealityName: [{ required: true, message: "随访人员不能为空！", trigger: "blur" }],
        isRegister: [{ required: true, message: "是否挂号不能为空！", trigger: "change" }],
        examTemplateId: [{ required: true, message: "复诊自动随访问卷模板不能为空！", trigger: "blur" }],
        hintMessage: [{ required: true, message: "日常自动随访问题描述不能为空！", trigger: "blur" }],
      }, // 验证规则
      templateOptions: [], // 随访模板列表
      type: null, // 随访类型
      formHeight: 500, // 表单高度
      tableHeight: 0, // 表格最大高度
      againVisible: false, // 再次推送模态框状态
      modifyList: [], // 需要再次推送的列表
      examTimeObj: { examTime: null }, // 再次推送时间对象
      hintList: [], // 日常随访模板
    };
  },
  created() {
    this.getFollowUpList(); // 请求患者随访列表
    if (this.$session.get('user').hospDoctorInfo.doctorId == null) this.getDoctorList(); // 获取所有馆内医生
    this.getTemplateList(); // 请求问卷列表
    this.getHintList(); // 获取日常随访列表
    this.tableHeight = document.documentElement.clientHeight - 320; // 计算表格最大高度
    this.formHeight = Math.floor(document.documentElement.clientHeight * 0.86 - 180); // 弹框表单最高高度
  },
  methods: {
    // 请求患者随访列表
    async getFollowUpList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, status: this.activeIndex, doctorName: this.searchForm.doctorName };
      let { total, rows, code } = await followUpList(params);
      if (code == 200) {
        this.total = total;
        rows.forEach(item => {
          switch (item.reply) {
            case '-1': item.replyStr = '待推送'; break;
            case '0': item.replyStr = '未回复'; break;
            case '1': item.replyStr = '已回复'; break;
          }
        })
        this.followUpList = rows;
        this.getStatusNum(); // 请求随访每个状态的数量
      }
      this.loading = false;
    },
    // 请求随访问卷模板列表
    async getTemplateList() {
      let { rows, code } = await templateList();
      if (code == 200) this.templateOptions = rows;
    },
    // 请求日常随访列表
    async getHintList() {
      let { rows, code, total } = await hintBankList();
      if (code == 200) this.hintList = rows;
    },
    // 获取每个状态数量
    async getStatusNum() {
      let { code, data } = await statusNum({ doctorName: this.searchForm.doctorName });
      if (code == 200) {
        this.noFollowUpNumber = data.noFollowUpNumber;
        this.followUpNumber = data.followUpNumber;
        this.beforeFollowUpNumber = data.beforeFollowUpNumber;
        this.afterFollowUpNumber = data.afterFollowUpNumber;
        this.waitPushNumber = data.waitPushNumber;
        this.erroPushNumber = data.erroPushNumber;
      }
    },
    // 修改随访状态
    async followUpModify(list, targetStatus) {
      if (list.length == 0) this.$message.warning('您还未选择随访项目，请选择后再试！');
      else {
        let modifyList = JSON.parse(JSON.stringify(list));
        modifyList.forEach(item => {
          item.status = targetStatus;
          item.examTime = null;
          item.reply = 0;
        });
        let { code } = await followUpModified(modifyList);
        if (code == 200) {
          if (modifyList.length == 1) {
            if (targetStatus == 0) this.$message.success('添加随访计划成功！');
            else this.$message.success('取消随访计划成功！');
          } else {
            if (targetStatus == 0) this.$message.success('批量添加随访计划成功！');
            else this.$message.success('批量取消随访计划成功！');
          }
          this.$refresh(this.getFollowUpList);
        }
      }
    },
    // 批量再次推送
    followUpAgain(list) {
      let modifyList = JSON.parse(JSON.stringify(list));
      if (list.length == 0) this.$message.warning('您还未选择随访项目，请选择后再试！');
      else {
        modifyList.forEach(item => {
          item.status = 1;
          item.examTime = null;
          item.reply = 0;
        });
        this.modifyList = modifyList;
        this.againVisible = true;
      }
    },
    async followUpAgainSave() {
      let modifyList = this.modifyList
      modifyList.forEach(item => { item.examTime = this.examTimeObj.examTime });
      let { code } = await followUpAgain(modifyList);
      if (code == 200) {
        if (modifyList.length == 1) this.$message.success('设置重新推送成功！');
        else this.$message.success('批量设置重新推送成功！');
        this.againVisible = false;
        this.examTimeObj.examTime = null;
        this.$refresh(this.getFollowUpList);
      }
    },
    // 随访分类改变
    targerChange(val) {
      if (val == 0) this.editForm.hintMessage = null;
      else this.editForm.examTemplateId = null;
    },
    // 设置随访问题
    async setQuestion(val) {
      if (this.type == '0') {
        let { code, rows } = await questionList({ examTemplateId: val });
        if (code == 200) {
          rows.forEach(item => {
            item.selectAnswerId = null;
            item.selectAnswerIds = [];
            item.templateAnswers.forEach(kid => { kid.examRecordAnswerId = kid.examTemplateAnswerId });
          })
          this.editForm.questionsList = rows;
        }
      }
    },
    // 设置单选答案
    setRadioAnswer(val, question) {
      question.templateAnswers.forEach(item => { item.answerSelect = 0 });
      question.templateAnswers.forEach(item => {
        if (item.examRecordAnswerId == val) {
          item.answerSelect = 1;
          question.testAnswer = item.answerContent;
        }
      });
    },
    // 设置复选框答案
    setCheckboxAnswer(val, question) {
      question.testAnswer = "";
      question.templateAnswers.forEach(item => { item.answerSelect = 0; });
      question.templateAnswers.forEach(item => {
        val.forEach(kid => {
          if (item.examRecordAnswerId == kid) {
            item.answerSelect = 1;
            question.testAnswer += item.answerContent + '，';
          }
        })
      });
      let len = question.testAnswer.length;
      question.testAnswer = question.testAnswer.substring(0, len - 1);
    },
    // 新建随访
    addFollowUp(obj, type) {
      this.type = type;
      this.editForm = {
        channel: null, examRealityName: this.$session.get('user').nickName, hintMessage: null, examTime: null,
        imgAddr: null, isRegister: null, questionsList: [], targer: null, visitTime: null, examTemplateId: null,
        examRecordId: obj.examRecordId, examRecordIds: [obj.examRecordId]
      }
      this.dialogVisible = true;
    },
    // 批量自动随访
    addFollowUpList(list) {
      this.type = '1';
      if (list.length > 0) {
        let examRecordIds = [];
        list.forEach(item => { examRecordIds.push(item.examRecordId) });
        this.editForm = {
          examRealityName: this.$session.get('user').nickName, hintMessage: null, examTime: null, isRegister: null,
          targer: null, visitTime: null, examTemplateId: null, examRecordIds: examRecordIds
        }
        this.dialogVisible = true;
      } else this.$message.warning('您还未选择随访项目，请选择后再试！');
    },
    // 保存随访
    saveFollowUp() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          if (this.type == '1') {
            followUpAuto(this.editForm).then(res => {
              if (res.code == 200) {
                this.$message.success('创建自动随访成功！');
                this.dialogVisible = false;
                this.$refresh(this.getFollowUpList);
                this.$refs['editForm'].resetFields();
              }
            });
          } else {
            followUpArtificial(this.editForm).then(res => {
              if (res.code == 200) {
                this.$message.success('创建人工随访成功！');
                this.dialogVisible = false;
                this.$refresh(this.getFollowUpList);
                this.$refs['editForm'].resetFields();
              }
            });
          }
        } else return false;
      })
    },
    // 查询所有馆内医生列表 --- 匹配医助
    async getDoctorList() {
      let assistantName = null;
      if (this.$session.get('user').type == 1) assistantName = this.$session.get('user').nickName;
      this.$getDoctorOptions({ type: 0, status: 0, assistantName: assistantName });
    },
    // 切换面板
    handleSelect() {
      this.$refresh(this.getFollowUpList);
    },
    // 图片上传成功
    handleImgSuccess(res) {
      let { code, msg } = res;
      if (code === 200) this.editForm.imgAddr = msg;
    },
    // 清除图片地址，显示上传图片
    editImg() {
      this.editForm.imgAddr = null;
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  .btn {
    position: fixed;
    right: 60px;
    margin-top: 5px;
    z-index: 10;
  }

  .el-tabs {
    padding-right: 300px;
  }
}</style>